<template>
  <el-table
    v-cloak
    :data="tableData"
    style="width: 100%"
    :header-cell-style="{
      background: '#e9f3fe',
      color: '#666666',
      fontSize: '12px',
      fontWeight: 'normal'
    }"
  >
    <el-table-column :label="t('costDate')" prop="costDate" width="150" />
    <el-table-column :label="t('pucsscxx')" prop="pucsscxx" width="180">
      <template slot-scope="scope">
        <span
          class="active"
        >{{ scope.row.purchaseSeq }}-{{ scope.row.purchasePhaseSeq }}-{{
          scope.row.purchaseBatchSeq
        }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="t('purchaseNo')" prop="purchaseNo" width="150" />
    <el-table-column :label="t('goodsNo')" prop="goodsNo" width="150" />
    <el-table-column :label="t('goodsName')" prop="goodsName" width="150" />
    <el-table-column :label="t('batchPurQty')" prop="batchPurQty" />
    <el-table-column :label="t('sourceSeq')" prop="sourceSeq">
      <template slot-scope="scope">
        <span class="active">{{ scope.row.purchaseSeq }}-{{ scope.row.purchasePhaseSeq }}-{{ scope.row.purchaseBatchSeq }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="t('sourceNo')" prop="sourceNo" width="150">
      <template slot-scope="scope">
        <span class="active">{{ scope.row.sourceNo }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="t('asnNo')" prop="asnNo" width="180" />
    <el-table-column :label="t('asnSeq')" prop="asnSeq" width="150" />
    <el-table-column :label="t('deliveryQty')" prop="deliveryQty" />
    <el-table-column :label="t('receiveQty')" prop="receiveQty" />
    <el-table-column :label="t('checkReturnQty')" prop="checkReturnQty" />
    <el-table-column :label="t('inStoreQty')" prop="inStoreQty">
      <template slot-scope="scope">
        <span class="active">{{ scope.row.inStoreQty }}</span>
      </template>
    </el-table-column>
    <el-table-column
      :label="t('chacuo')"
      prop="chacuo"
      width="150"
    >
      <template slot-scope="scope">
        <span v-if="scope.row.diffSign === 'Y'" style="color:#E6424F">{{ t('abnormal') }}</span>
        <span v-if="scope.row.diffSign === 'N'">{{ t('normality') }}</span>
      </template>
    </el-table-column>
    <el-table-column
      :label="t('duizhang')"
      prop="duizhang"
      width="150"
    >
      <template slot-scope="scope">
        <span
          v-if="
            scope.row.purConfirmSign === 'Y' && scope.row.supConfirmSign === 'N'
          "
        >{{ t('pucssyes') }}</span>
        <span
          v-if="
            scope.row.purConfirmSign === 'N' && scope.row.supConfirmSign === 'Y'
          "
        >{{ t('supyes') }}</span>
        <span
          v-if="
            scope.row.purConfirmSign === 'Y' && scope.row.supConfirmSign === 'Y'
          "
        >{{ t('myheyes') }}</span>
        <span
          v-if="
            scope.row.purConfirmSign === 'N' && scope.row.supConfirmSign === 'N'
          "
        >{{ t('myheNo') }}</span>
      </template>
    </el-table-column>
    <el-table-column
      :label="t('kaipiao')"
      prop="kaipiao"
      width="150"
    >
      <template slot-scope="scope">
        <span v-if="scope.row.invoiceSign === 'Y'">{{ t('yikaipiao') }}</span>
        <span v-if="scope.row.invoiceSign === 'N'">{{ t('weikaipiao') }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableData: [
        {
          costDate: '',
          a: '',
          pucsscxx: '',
          goodsNo: '',
          goodsName: '',
          sourceSeq: '',
          sourceNo: '',
          asnNo: '',
          asnSeq: '',
          deliveryQty: '',
          receiveQty: '',
          checkReturnQty: '',
          inStoreQty: '',
          purchaseSeq: '',
          purchasePhaseSeq: '',
          purchaseBatchSeq: ''
        }
      ]
    }
  },
  watch: {
    data(n) { // n为新值,o为旧值;
      const arr = [...n]
      this.tableData = arr
    }
  },
  created() {
    // this.getfatherInfo()
    console.log(this.data)
  },
  methods: {
    t(key) {
      return this.$t(`bill.table.${key}`)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/th .cell {
  color: #333333;
  font-size: 14px;
  font-weight: 600;
}
td .cell {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
}
.active {
  // cursor: pointer;
  // color: #31a3e8;
}
</style>
